export default function FormatDateTime({date, timezome='', empty='' }){
    const options = {}
    if (timezome) {
        options['timeZone'] = timezome
    }
    return date ? formatDateTime(new Date(date)) : empty
}

function formatDateTime(date, options) {
    return `${date.toLocaleDateString("en-US", options)} ${date.toLocaleTimeString("en-US", options)}`
}
